import React from "react";
import "../styles/PolicyPages.css";

const KullanimSartlari = () => {
  return (
    <div className="policy-page">
      <h1>Kullanım Şartları</h1>
      <p>
        <strong>Son Güncelleme:</strong> 09.04.2026
      </p>
      <p>
        Patili Dostlar platformunu kullanmanız, aşağıda yer alan kullanım
        şartlarını okuduğunuzu, anladığınızı ve kabul ettiğinizi gösterir. Bu
        şartlar, platformun güvenli, düzenli ve amacına uygun şekilde
        kullanılmasını sağlamak amacıyla hazırlanmıştır.
      </p>

      <h3>1. Genel Hükümler</h3>
      <p>
        Platform, hayvan sahiplendirme ve ilgili başvuru süreçlerine aracılık
        eden bir çevrim içi hizmettir. Platforma erişen her kullanıcı,
        yürürlükte bulunan mevzuata, kamu düzenine, genel ahlaka ve işbu
        kullanım şartlarına uygun davranmakla yükümlüdür.
      </p>

      <h3>2. Kullanıcı Yükümlülükleri</h3>
      <ul>
        <li>
          Kayıt ve başvuru sırasında doğru, eksiksiz ve güncel bilgi vermek.
        </li>
        <li>
          Yanıltıcı, sahte veya üçüncü kişilerin haklarını ihlal eden içerik
          oluşturmamak.
        </li>
        <li>
          Platformu kötüye kullanmamak, sistemin işleyişini bozacak işlemler
          yapmamak.
        </li>
        <li>
          Başka kullanıcılara, hayvanlara veya platforma zarar verecek
          davranışlardan kaçınmak.
        </li>
        <li>
          Hesap bilgilerini üçüncü kişilerle paylaşmamak ve güvenliğini
          sağlamak.
        </li>
      </ul>

      <h3>3. İlan ve İçerik Kuralları</h3>
      <ul>
        <li>
          Yalnızca gerçeğe uygun, güncel ve ilgili hayvana ait bilgiler
          paylaşılabilir.
        </li>
        <li>
          İlan sahibi, verdiği ilana ilişkin kendisine yöneltilen başvurulara en
          geç 5 iş günü içinde dönüş sağlamakla yükümlüdür; bu süre içinde dönüş
          yapılmaması halinde ilgili ilan yönetim tarafından silinebilir.
        </li>
        <li>
          İzinsiz, telif hakkı ihlali içeren veya hukuka aykırı görsel ve
          metinler kullanılamaz.
        </li>
        <li>
          Hakaret, ayrımcılık, tehdit, dolandırıcılık veya yanıltıcı içerik
          yasaktır.
        </li>
        <li>
          Platform yönetimi, uygun görmediği içerikleri önceden bildirim
          yapmaksızın kaldırma hakkını saklı tutar.
        </li>
      </ul>

      <h3>4. Hesap Güvenliği</h3>
      <p>
        Kullanıcı, hesabının güvenliğinden sorumludur. Şifrelerin gizli
        tutulması ve hesabın yetkisiz kullanımının önlenmesi kullanıcı
        sorumluluğundadır. Şüpheli bir durum tespit edilmesi halinde derhal
        platform yönetimine bilgi verilmelidir.
      </p>

      <h3>5. Sorumluluğun Sınırı</h3>
      <p>
        Platform, hizmetin kesintisiz veya hatasız olacağını taahhüt etmez.
        Teknik arızalar, bakım çalışmaları, internet altyapısı kaynaklı
        kesintiler, üçüncü kişi saldırıları veya mücbir sebepler nedeniyle
        doğabilecek aksaklıklardan, mevzuatın emredici hükümleri saklı kalmak
        kaydıyla, yalnızca kusuru oranında sorumludur.
      </p>

      <h3>6. Fikri Mülkiyet</h3>
      <p>
        Platformda yer alan tüm marka, tasarım, metin, görsel, yazılım ve diğer
        içerikler aksi açıkça belirtilmedikçe Patili Dostlar'a veya ilgili hak
        sahiplerine aittir. Bu içerikler izinsiz kopyalanamaz, çoğaltılamaz,
        dağıtılamaz veya ticari amaçla kullanılamaz.
      </p>

      <h3>7. Askıya Alma ve Sonlandırma</h3>
      <p>
        Kullanım şartlarına, ilgili mevzuata veya platform kurallarına aykırı
        davranılması halinde kullanıcı hesabı geçici olarak askıya alınabilir,
        kalıcı olarak sonlandırılabilir veya silinebilir. Özellikle sahte ilan
        oluşturulması, yanıltıcı başvuru yapılması, kötü niyetli kullanım veya
        platformun amacını zedeleyen davranışlar tespit edilmesi halinde ilgili
        hesaplar yönetim tarafından kaldırılabilir.
      </p>

      <h3>8. Değişiklikler</h3>
      <p>
        Patili Dostlar, işbu kullanım şartlarını dilediği zaman güncelleme
        hakkını saklı tutar. Güncellenen metin platformda yayımlandığı anda
        yürürlüğe girer.
      </p>

      <h3>9. İletişim</h3>
      <p>
        İşbu kullanım şartlarına ilişkin soru ve talepleriniz için platformda
        yer alan iletişim kanalları veya e-posta adresi üzerinden bizimle
        iletişime geçebilirsiniz.
      </p>
      <p>
        Platformu kullanmaya devam eden her kullanıcı, bu kullanım şartlarında
        yapılan güncellemeleri de kabul etmiş sayılır.
      </p>
    </div>
  );
};
export default KullanimSartlari;
